import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'

const FINANCE_ENDPOINTS: Partial<Record<Roles, string>> = {
  [Roles.Trader]: '/v1/trader/finances',
  [Roles.Merchant]: '/v1/merchant/finances',
} as const

const getEndpoint = (): string => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  return userRole ? FINANCE_ENDPOINTS[userRole]! : FINANCE_ENDPOINTS[Roles.Trader]!
}

export const financesAPI = {
  get baseKey() {
    return getEndpoint()
  },
  get() {
    return this.baseKey
  },
}
